import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { StringifyTradePlan } from '../../../../../../../../stores/websocketStore/utils/mungingUtils/stringifyTradePlan/StringifyTradePlan';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import style from './OverviewPanel.module.css';

export const OverviewPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
    if (!tradePlan) return null;

    return <TabPanel {...rest}>
      <div className={style.container}>
        <StringifyTradePlan tradePlan={tradePlan} />
      </div>
    </TabPanel>;
  }
);

OverviewPanel.tabsRole = 'TabPanel';
